import 'bootstrap/dist/css/bootstrap.min.css'
import { withPrefix } from 'gatsby-link'
import PropTypes from 'prop-types'
import React from 'react'
import Helmet from 'react-helmet'
import Footer from '../components/Footer'
import Navigation from '../components/Navbar'
import './all.scss'


const TemplateWrapper = ({ children, location }) => {

  let darkmode = '';
  let displayNav = true;
  
  if ((location.pathname === withPrefix ("/lp-kupl/")) || (location.pathname === withPrefix ("/lp-oudo/")) ) {
    displayNav = false;
  } else {
    displayNav = true;
  }

  if (location.pathname === withPrefix ("/outdoorkuechen/")) {
    darkmode = 'dark';
  } else {
    darkmode = '';
  }

  return(
  <div className={darkmode}>
    <Helmet title="Marmor Fischer GmbH" />
    { displayNav && <Navigation theming={darkmode} /> }
    <main>{children()}</main>
    <Footer theming={darkmode} />
  </div>

  );
  
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js